module.exports = __webpack_public_path__ + "img/MBOMDetailed-min.3664f58d.png";